/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyleposterhint4Inputs */

const en_aiflowstyleposterhint4 = /** @type {(inputs: Aiflowstyleposterhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold, flat`)
};

const de_aiflowstyleposterhint4 = /** @type {(inputs: Aiflowstyleposterhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kräftig, flach`)
};

/**
* | output |
* | --- |
* | "Bold, flat" |
*
* @param {Aiflowstyleposterhint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyleposterhint4 = /** @type {((inputs?: Aiflowstyleposterhint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyleposterhint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyleposterhint4(inputs)
	return de_aiflowstyleposterhint4(inputs)
});
export { aiflowstyleposterhint4 as "aiFlowStylePosterHint" }